import { render, staticRenderFns } from "./CurrentTab.vue?vue&type=template&id=e9a2e012&"
import script from "./CurrentTab.vue?vue&type=script&lang=ts&"
export * from "./CurrentTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection})
